import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RepuestosService {
  private apiUrl =  environment.apiUrl;

  constructor(private http: HttpClient) { }

  getRepuestosPaginados(
    page: number, 
    limit: number, 
    sortBy: string, 
    sortOrder: string, 
    search: string,
    familia: string,
    estado: string = 'activos'
  ): Observable<{ data: any[], total: number }> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder)
      .set('search', search)
      .set('familia', familia)
      .set('estado', estado);

    return this.http.get<{ data: any[], total: number }>(`${this.apiUrl}/repuestos`, { params });
  }

  // Método para obtener las familias para el autocomplete
  getFamilias(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/repuestos/familias`);
  }

  getRepuestosParaExportar(
    sortBy: string, 
    sortOrder: string, 
    search: string,
    familia: string,
    estado: string = 'activos'
  ): Observable<{ data: any[] }> {
    let params = new HttpParams()
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder)
      .set('search', search)
      .set('familia', familia)
      .set('estado', estado)
      .set('export', 'true');
      
    return this.http.get<{ data: any[] }>(`${this.apiUrl}/repuestos`, { params });
  }

  getRepuestos(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/repuestos`);
  }

  getRepuesto(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/repuestos/${id}`);
  }

  crearRepuesto(repuesto: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/repuestos`, repuesto);
  }

  actualizarRepuesto(id: number, repuesto: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/repuestos/${id}`, repuesto);
  }

  eliminarRepuesto(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/repuestos/${id}`);
  }

  // Nuevos métodos para gestionar precios por cliente
  getClientePreciosForRepuesto(repuestoId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/cliente-repuesto/repuesto/${repuestoId}`);
  }

  updateClienteRepuesto(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/cliente-repuesto/${id}`, data);
  }

  createClienteRepuesto(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/cliente-repuesto`, data);
  }

  getHistorialClienteRepuesto(clienteRepuestoId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/cliente-repuesto/${clienteRepuestoId}/historial`);
  }

  sincronizarClientesRepuestos(): Observable<{ creados: number }> {
    return this.http.post<{ creados: number }>(
      `${this.apiUrl}/repuestos/sincronizar-clientes`,
      {}
    );
  }

  getHideCargaMasiva(): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/repuestos/ocultar-carga-masiva`);
  }

  // Restauración cuando el repuesto tiene eliminado lógico.
  restaurarRepuesto(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/repuestos/${id}/restaurar`, {});
  }
}
